import { toast } from 'react-toastify';
import { ReactComponent as CheckCircle } from '../../icons/check_circle.svg';
import { ReactComponent as EmergencyHome } from '../../icons/emergency_home.svg';
import { ReactComponent as Error } from '../../icons/error.svg';
import ButtonField from "../buttonField/buttonField";
import { SnackbarProps } from './types/snackbarProps';
import './snackbar.scss';

export const notifySuccess = (props: SnackbarProps) => {
    toast.success(getContent("success", props), {
        theme: "colored",
        position: "top-center",
        bodyStyle: {
            width: '50vw'
        },
        icon: ({ theme, type }) => { return (<CheckCircle width={24} height={24} fill='#96A85F'/>); }
    });
};

export const notifyWarn = (props: SnackbarProps) => {
    toast.warn(getContent("warning", props), {
        theme: "colored",
        position: "top-center",
        bodyStyle: {
            width: '50vw'
        },
        icon: ({ theme, type }) => { return (<EmergencyHome width={24} height={24} />); }
    });
};

export const notifyError = (props: SnackbarProps) => {
    toast.error(getContent("error", props), {
        theme: "colored",
        position: "top-center",
        bodyStyle: {
            width: '50vw'
        },
        icon: ({ theme, type }) => { return (<Error width={24} height={24} />); }
    });
};

const getContent = (snackType: string, props: SnackbarProps) => {
    return <div className='Toastify__custom-content'>{props.message} {getBtn(snackType, props.btnText, props.onClick)}</div>;
};

const getBtn = (snackType: string, btnText?: string, onClick?: Function) => {
    if (typeof onClick === 'function') {
        const text = btnText ? btnText : "Click!";
        return <ButtonField
            BtnProps={{
                onClick: () => { onClick() },
                className: btnClass(snackType)
            }}
            placeHolder={text}
        />
    }
    return null;
};

const btnClass = (snackType: string) => {
    return `body-txt-medium Toastify__custom-buttons Toastify__custom-buttons--${snackType}`;
}
